import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const allowanceSlice = createSlice({
  name: "allowance",

  initialState: {
    allowance: [],
  },
  reducers: {
    setEmployeeAllowance: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.allowance = payload;
    },

    resetEmployeeAllowance: (state: any) => {
      state = [];
    },
  },
});

export const { resetEmployeeAllowance, setEmployeeAllowance } =
  allowanceSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default allowanceSlice.reducer;
